// Copyright 2025. WebPros International GmbH. All rights reserved.

export const TASKS_TABLE = {
    CANCEL_BUTTON: 'tasks-cancel',
    RETRY_BUTTON: 'tasks-retry',
    MODAL_LINK: 'tasks-modal-link',
};
